import { Polygon } from '@visx/shape'
import type { Ref } from 'react'

type Props = {
  /** Short axis length */
  shortAxis: number
  /** Long axis length */
  longAxis: number
  /** Orientation */
  orientation: 'horizontal' | 'vertical'
  /** Externally defined classNames */
  className: string
  /** Coordinates for the rhombus center */
  center: { x: number; y: number }
  ref?: Ref<SVGPolygonElement>
}

/** Draws an SVG Rhombus shape. */
export const Rhombus = ({
  ref,
  shortAxis,
  longAxis,
  orientation,
  className,
  center: { x, y },
}: Props) => {
  const verticalPoints: [number, number][] = [
    [x, y - longAxis / 2],
    [x - shortAxis / 2, y],
    [x, y + longAxis / 2],
    [x + shortAxis / 2, y],
  ]

  const horizontalPoints: [number, number][] = [
    [x + longAxis / 2, y],
    [x, y - shortAxis / 2],
    [x - longAxis / 2, y],
    [x, y + shortAxis / 2],
  ]

  return (
    <Polygon
      innerRef={ref}
      points={orientation === 'vertical' ? verticalPoints : horizontalPoints}
      className={className}
    />
  )
}
